import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { Package, ShoppingBag } from "lucide-react";

export default function Account() {
  const { user, ready } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && user !== false) {
      api.get("/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
    }
  }, [user]);

  if (!ready) return <div className="text-center py-32 text-gray-400">Loading…</div>;
  if (user === false) return <Navigate to="/login" state={{ from: "/account" }} replace />;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="bg-[#F8F9FA] rounded-3xl p-8 mb-8">
        <p className="text-gray-500 text-sm">Welcome back,</p>
        <h1 className="font-display font-black text-3xl">{user.name || user.email}</h1>
        <p className="text-gray-500 text-sm mt-1">{user.email}</p>
      </div>

      <h2 className="font-display font-bold text-2xl mb-6 flex items-center gap-2"><Package className="w-6 h-6 text-[#FF5C28]" /> Order History</h2>

      {loading ? (
        <p className="text-gray-400">Loading orders…</p>
      ) : orders.length === 0 ? (
        <div className="text-center py-16 bg-[#F8F9FA] rounded-3xl" data-testid="no-orders">
          <ShoppingBag className="w-12 h-12 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 mb-6">You haven't placed any orders yet.</p>
          <Link to="/shop" className="rounded-full bg-[#FF5C28] text-white font-bold px-6 py-3 hover:bg-[#E04D1E] transition-colors">Start Shopping</Link>
        </div>
      ) : (
        <div className="space-y-4" data-testid="orders-list">
          {orders.map((o) => (
            <div key={o.session_id} className="bg-white border border-gray-100 rounded-2xl p-6">
              <div className="flex justify-between items-start mb-3">
                <div>
                  <p className="font-display font-bold">Order · {new Date(o.created_at).toLocaleDateString()}</p>
                  <p className="text-sm text-gray-500">{o.line_summary?.join(", ")}</p>
                </div>
                <div className="text-right">
                  <p className="font-display font-black text-lg">${o.amount?.toFixed(2)}</p>
                  <span className="text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full">Paid</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
